import React from "react";
import {ButtonGroup, Stack} from "@mui/material";
import {EditCompanyProfileButton, EditCompanyProfileLabelText} from "./EditCompanyProfile/style";

interface ChargeModelButtonProps {
    useCalendarDays?: boolean;
    setUseCalendarDays: (useCalendarDays: boolean) => void;
}

const ChargeModelButton = (props: ChargeModelButtonProps) => {
    const {useCalendarDays, setUseCalendarDays} = props;

    return (
      <Stack gap={'0.57rem'} alignItems={'flex-start'}>
        <EditCompanyProfileLabelText variant={'subtitle1'} color={'textSecondary'}>Charge
          Model</EditCompanyProfileLabelText>
        <ButtonGroup>
          <EditCompanyProfileButton
            className={`d-flex ss-tab-btn`}
            onClick={() => setUseCalendarDays(false)}
            variant={!useCalendarDays ? "contained" : "outlined"}
            color={!useCalendarDays ? "primary" : "secondary"}
          >
            24 Hour
          </EditCompanyProfileButton>
          <EditCompanyProfileButton
            className={`d-flex ss-tab-btn`}
            onClick={() => setUseCalendarDays(true)}
            variant={useCalendarDays ? "contained" : "outlined"}
            color={useCalendarDays ? "primary" : "secondary"}
          >
            Calendar Days
          </EditCompanyProfileButton>
        </ButtonGroup>
      </Stack>
    )
}

export default ChargeModelButton;
